// Generated by CoffeeScript 2.7.0
var Field;

import Base from './base.js';

import CascadedSelect from './cascaded_select.js';

import CheckBox from './check_box.js';

import DateTime from './date_time.js';

import Detail from './detail.js';

import File from './file.js';

import Integer from './integer.js';

import IDNumber from './idnumber.js';

import Location from './location.js';

import Member from './member.js';

import Organization from './organization.js';

import RadioButton from './radio_button.js';

import Rating from './rating.js';

import SectionBreak from './section_break.js';

import TextArea from './text_area.js';

import TextField from './text_field.js';

import Page from './page.js';

import Phone from './phone.js';

import Calculation from './calculation.js';

import Esignature from './esignature.js';

Field = {Base, CheckBox, RadioButton, CascadedSelect, DateTime, Detail, File, Integer, Location, Member, Organization, Rating, SectionBreak, TextArea, TextField, Page, IDNumber, Phone, Calculation, Esignature};

Base.constantize = function(field_type) {
  return Field[field_type.demodulize()] || (function() {
    throw `Invalid field_type: ${field_type}`;
  })();
};

Base.new = function(attrs, logic_settings = {}, fieldable) {
  var model_klass;
  if (attrs instanceof this) {
    attrs.fieldable = fieldable;
    attrs.logic_rule = logic_settings[attrs.id];
    return attrs;
  } else {
    model_klass = Base.constantize(attrs.type);
    return new model_klass(attrs, logic_settings, fieldable);
  }
};

export default Field;
